import React from 'react';
import styles from './sections.module.css';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface AboutSectionProps {
  project: any;
}

export const AboutSection: React.FC<AboutSectionProps> = ({ project }) => {
  const ref = useScrollReveal();
  const pw = project.publicWebsite;
  const about = pw?.about || {};
  const heading = about.heading || 'Over het project';
  const body = about.body || project.description || '';
  const location = project.location;

  return (
    <section id="about" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>{heading}</h2>
        {about.image && (
          <div className={styles.sectionImage}>
            <img src={about.image} alt={heading} />
          </div>
        )}
        <div className={styles.aboutGrid}>
          <div className={styles.aboutText}>
            {body.split('\n').map((p: string, i: number) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          {about.showLocation !== false && location && (
            <div className={styles.aboutInfo}>
              <div className={styles.infoCard}>
                <h4>Projectinformatie</h4>
                {location.city && (
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Locatie</span>
                    <span>{location.address ? `${location.address}, ${location.city}` : location.city}</span>
                  </div>
                )}
                {project.startDate && (
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Startdatum</span>
                    <span>{new Date(project.startDate).toLocaleDateString('nl-NL', { year: 'numeric', month: 'long' })}</span>
                  </div>
                )}
                {project.endDate && (
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Einddatum</span>
                    <span>{new Date(project.endDate).toLocaleDateString('nl-NL', { year: 'numeric', month: 'long' })}</span>
                  </div>
                )}
                {project.company && (
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Opdrachtgever</span>
                    <div>
                      {project.company.logo && (
                        <img
                          src={project.company.logo}
                          alt={project.company.name}
                          style={{ height: '36px', objectFit: 'contain', marginBottom: '4px', display: 'block' }}
                        />
                      )}
                      <span>{project.company.name}</span>
                    </div>
                  </div>
                )}
                {project.status && (
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Status</span>
                    <span className={styles.statusBadge}>
                      {project.status === 'active' ? 'Actief' : project.status === 'planning' ? 'Planning' : project.status}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
